import { render, staticRenderFns } from "./ChatLog.vue?vue&type=template&id=9b78ac70&"
import script from "./ChatLog.vue?vue&type=script&lang=js&"
export * from "./ChatLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b78ac70')) {
      api.createRecord('9b78ac70', component.options)
    } else {
      api.reload('9b78ac70', component.options)
    }
    module.hot.accept("./ChatLog.vue?vue&type=template&id=9b78ac70&", function () {
      api.rerender('9b78ac70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/chat/ChatLog.vue"
export default component.exports